var moduleMap = {
	"./AppPadSales": () => {
		return Promise.all([__webpack_require__.e(2170), __webpack_require__.e(2726), __webpack_require__.e(7900), __webpack_require__.e(4986), __webpack_require__.e(7522), __webpack_require__.e(9770), __webpack_require__.e(1778), __webpack_require__.e(7405), __webpack_require__.e(8569), __webpack_require__.e(1206), __webpack_require__.e(8575), __webpack_require__.e(9078), __webpack_require__.e(108)]).then(() => (() => ((__webpack_require__(50108)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});